import React, { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Profile from '../../components/dashboard/Profile';
import DashboardLayout from 'components/layouts/dashboard/Layout';
import useUserStore from 'state/userStore';

const Dashboard: FC = () => {
  window.document.title = 'Dashboard';
  const { pathname } = useLocation();
  const { user } = useUserStore();

  return (
    <DashboardLayout>
      <section className="w-full rounded-md bg-zinc-50 p-5 md:mx-auto md:h-screen lg:container">
        {pathname === '/dashboard' && (
          <div className="flex w-full items-center justify-between py-1">
            <h3 className="text-[20px] lg:text-2xl">
              Welcome back,{' '}
              <span className="font-semibold">{user?.fullName}</span> 👋
            </h3>
            <div className="hidden md:block">
              <Profile />
            </div>
          </div>
        )}

        <Outlet />
      </section>
    </DashboardLayout>
  );
};

export default Dashboard;
